import { baseApi, ENDPOINTS } from '@/shared/api';

import type {
    NotificationPaginatedResponse,
    NotificationsParams,
} from '../model/types/notification';

const notificationApi = baseApi
    .enhanceEndpoints({
        addTagTypes: ['Notification'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getNotifications: build.query<
                NotificationPaginatedResponse,
                NotificationsParams
            >({
                providesTags: ['Notification'],
                query: (params) => ({
                    url: ENDPOINTS.notification.getAll,
                    method: 'GET',
                    params,
                }),
                transformResponse: (response: unknown) => {
                    const typedResponse =
                        response as NotificationPaginatedResponse;

                    return {
                        results: typedResponse.results || [],
                        count: typedResponse.count || 0,
                        next: typedResponse.next || null,
                        previous: typedResponse.previous || null,
                    };
                },
            }),
            markAsRead: build.mutation<void, number>({
                invalidatesTags: ['Notification'],
                query: (id) => ({
                    url: ENDPOINTS.notification.markAsRead(id),
                    method: 'PUT',
                }),
            }),
            markAllAsRead: build.mutation<void, void>({
                invalidatesTags: ['Notification'],
                query: () => ({
                    url: ENDPOINTS.notification.markAllAsRead,
                    method: 'POST',
                }),
            }),
            markAsDelivered: build.mutation<
                { id: number; delivered: boolean },
                number
            >({
                invalidatesTags: ['Notification'],
                query: (id) => ({
                    url: ENDPOINTS.notification.markAsDelivered(id),
                    method: 'PUT',
                }),
            }),
        }),
    });

export const {
    useGetNotificationsQuery,
    useMarkAsReadMutation,
    useMarkAllAsReadMutation,
    useMarkAsDeliveredMutation,
} = notificationApi;

export const getNotificationsFulfilled =
    notificationApi.endpoints.getNotifications.matchFulfilled;
